export const APP_CHECK_VIEW_PORT = 'APP_CHECK_VIEW_PORT';
export const APP_UPDATE_PROGRESS = 'APP_UPDATE_PROGRESS';
export const CURRENT_PROCESS_INFO_CLOSE = 'CURRENT_PROCESS_INFO_CLOSE';
export const CURRENT_PROCESS_INFO_OPEN = 'CURRENT_PROCESS_INFO_OPEN';
export const CURRENT_PROVIDER_CONTENT_OPEN = 'CURRENT_PROVIDER_CONTENT_OPEN';
export const CURRENT_PROVIDER_CONTENT_CLOSE = 'CURRENT_PROVIDER_CONTENT_CLOSE';
export const UPDATE_CURRENT_PROVIDER_CONTENT = 'UPDATE_CURRENT_PROVIDER_CONTENT';
